import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {
  MDBContainer,
  MDBBtn
}
from 'mdb-react-ui-kit';
import '../css/index.css';
import HomeADM from '../components/homes/home-adm'
import HomeEscola from '../components/homes/home-escola'
import HomeFilial from '../components/homes/home-filial'
import HomeResponsavel from '../components/homes/home-responsavel'
import HomePorteiro from '../components/homes/home-porteiro'
import HomeTurma from '../components/homes/home-turma'
import Logo from '../components/logos/logo'


function Home() {
  const api = require('../utils/index');
  const user = api.getUser()
  const navigate = useNavigate();
  
  return (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      
    <MDBContainer className='w-100 d-flex flex-column justify-content-center align-items-center'>
        {user.tipouser === 5 && (<HomeADM {...user}/>)}
        {user.tipouser === 4 && (<HomeEscola {...user}/>)}
        {user.tipouser === 3 &&(<HomeFilial {...user}/>)}
        {user.tipouser === 2 &&(<HomeTurma {...user}/>)}
        {user.tipouser === 6 &&(<HomePorteiro {...user}/>)}
        {user.tipouser === 1 &&(<HomeResponsavel {...user}/>)}
      </MDBContainer>
        <MDBContainer className='d-flex justify-content-center mt-5 align-items-center w-100'>
          <MDBBtn 
            className='btn-home w-25 mt-5 bg-dark'
            size='sm'
            outline
            color='white'
            onClick={() => {
              api.removeUser();
              navigate('/');
            }}
            >Sair
          </MDBBtn>
        
    </MDBContainer>
  </div>
  );
}

export default Home;